import { LineHeightOutlined } from "@ant-design/icons";
import FormHelpers from "../../../../helpers/FormHelpers";

const ERROR_MESSAGES = {
  requiredField: (fieldName) => `Error in ${fieldName} field. Select/Enter a valid value then proceed.`,
};

const validateDocLevel = ({
  rfqName, endTime, rfqNumber,
}) => {
  const errors = [];
  if (!rfqNumber) {
    errors.push({
      name: "RfqNumber",
      value: "",
      message: "Error in 'RFQ Number'. Please enter a valid value then proceed."
    })
  }
  if (!rfqName) {
    errors.push({
      name: "RfqName",
      value: "",
      message: "Error in 'RFQ Name'. Please enter a valid value then proceed."
    })
  }
  if (!endTime) {
    errors.push({
      name: "Deadline",
      value: "",
      message: "Error in 'Deadline'. Please select a date then proceed."
    })
  }
  return errors;
};

const validateLineLevel = ({ data }) => {
  const errors = [];
  if (data)  {
    data.forEach((item) => {
      if (!item?.product_sku_name) {
        errors.push({
          name: "Products",
          value: 0,
          message: "Error in Product. Select a product to continue.",
        });
      } else {
        if(!item?.quantity){
          errors.push({
            name: `Quantity in Product ${item?.internal_sku_code || ""}`,
            value: 0,
            message: ERROR_MESSAGES.requiredField(`Quantity in Product '${item?.internal_sku_code || ""}'`)
          })
        }
        if(!item?.delivery_tenant_id){
          errors.push({
            name: `Delivery Location in Product ${item?.internal_sku_code || ""}`,
            value: 0,
            message: ERROR_MESSAGES.requiredField(`Delivery Location in Product '${item?.internal_sku_code || ""}'`)
          })
        }
        if(!item?.delivery_date){
          errors.push({
            name: `Delivery Date in Product ${item?.internal_sku_code || ""}`,
            value: 0,
            message: ERROR_MESSAGES.requiredField(`Delivery Date in Product '${item?.internal_sku_code || ""}'`)
          })
        }
        if(!item?.tax_info){
          errors.push({
            name: `Tax in Product ${item?.internal_sku_code || ""}`,
            value: 0,
            message: ERROR_MESSAGES.requiredField(`Tax in Product '${item?.internal_sku_code || ""}'`)
          })
        }
        
      }
    });
  }

  return errors;
};

const rfqErrorList = (params) => {
  const docLevelErrors = validateDocLevel(params);
  const lineLevelErrors = validateLineLevel(params);
  
  return FormHelpers.errorChecker({ docLevelErrors, lineLevelErrors});
};

export default rfqErrorList;